import { AuthService } from "./../../shared/models/auth.service";
import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { WeGoConfig, IAPIResponse, DataListModel } from "../../shared/config";

@Injectable()
export class SignupFormConfigService {
  constructor(private authService: AuthService, private http: Http) {}

  public GetSignupFormList(input?: DataListModel): Observable<IAPIResponse> {
    let getSignupConfigUrl = WeGoConfig.API_GET_SIGNUP_CONFIG_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getSignupConfigUrl = getSignupConfigUrl + "?" + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSignupConfigUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSignupFormByHashId(
    instanceHashId: string
  ): Observable<IAPIResponse> {
    let getSignupConfigUrl =
      WeGoConfig.API_GET_SIGNUP_CONFIG_BY_HASH +
      "?signupFormConfigHashID=" +
      instanceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSignupConfigUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdateSignupFormConfig(bodyData: any): Observable<IAPIResponse> {
    let body = bodyData;
    let headers = this.authService.GetHeader(
      "application/json",
      "application/x-www-form-urlencoded"
    );
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_SIGNUP_CONFIG_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public DeleteSignupFormConfig(
    selectedTemplates: string[]
  ): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(
        WeGoConfig.API_POST_DELETE_SIGNUP_CONFIG,
        selectedTemplates,
        options
      )
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSignupFormDetails(signupParam: string): Observable<IAPIResponse> {
    let getSignupConfigUrl =
      WeGoConfig.API_GET_SIGNUP_CONFIG_DETAILS +
      "?signupFormParam=" +
      signupParam;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSignupConfigUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSubscriptionList(
    organizationHashId: string,
    signupFormConfigHashId: string
  ): Observable<IAPIResponse> {
    let getSubscriptionListUrl = WeGoConfig.API_GET_SUBSCRIPTION_LIST_SIGNUP;

    getSubscriptionListUrl =
      getSubscriptionListUrl +
      "?organizationHashId=" +
      organizationHashId +
      "&SignupFormConfigHashId=" +
      signupFormConfigHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSubscriptionListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportSignupConfigList(input?: DataListModel): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getSignupFormListUrl = WeGoConfig.API_EXPORT_SIGNUP_CONFIG;

    if (queryString) {
      getSignupFormListUrl = getSignupFormListUrl + "?" + queryString;
    }

    let headers = this.authService.GetHeader("text/csv");
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getSignupFormListUrl, options);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/signupform/models/signupfromconfig.service.ts